import { render, staticRenderFns } from "./ModalSlider.vue?vue&type=template&id=5024e3af&"
import script from "./ModalSlider.vue?vue&type=script&lang=js&"
export * from "./ModalSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports